module.exports = __webpack_public_path__ + "68c075201a48ed355683cf03733f8b1b.pdf";